module.exports = __webpack_public_path__ + "static/media/dependable-electrical.22147fce.png";